var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoplushome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.523,
    height: 50,
    viewBox: "0 0 152.523 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132669",
    "data-name": "Group 132669",
    transform: "translate(-123.999 -570)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "building-3",
    transform: "translate(225.563 570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91183",
    "data-name": "Path 91183",
    d: "M51.19,23.288H2.269a1.019,1.019,0,1,1,0-2.038H51.19a1.019,1.019,0,1,1,0,2.038Z",
    transform: "translate(-1.25 26.687)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91184",
    "data-name": "Path 91184",
    d: "M3.294,51.652a1.019,1.019,0,0,1-1.019-1.019L2.25,14.089A5.912,5.912,0,0,1,4.877,9.182l9.787-6.533a5.9,5.9,0,0,1,6.564,0L31.011,9.18a5.866,5.866,0,0,1,2.63,4.908l.024,36.494a1.019,1.019,0,0,1-1.017,1.02L3.3,51.652ZM17.946,3.691a3.837,3.837,0,0,0-2.147.652L6.012,10.876a3.875,3.875,0,0,0-1.724,3.213l.024,35.523,27.314-.046L31.6,14.089a3.835,3.835,0,0,0-1.72-3.211L20.095,4.345A3.839,3.839,0,0,0,17.946,3.691Z",
    transform: "translate(0.196 -1.652)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91185",
    "data-name": "Path 91185",
    d: "M20.249,29.1a1.019,1.019,0,0,1-1.019-1.019V18.269a1.019,1.019,0,0,1,2.038,0v9.809A1.019,1.019,0,0,1,20.249,29.1Z",
    transform: "translate(24.75 20.903)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91186",
    "data-name": "Path 91186",
    d: "M23.161,11.25a5.918,5.918,0,0,1,5.911,5.911v4.892a5.911,5.911,0,0,1-11.823,0V17.161A5.918,5.918,0,0,1,23.161,11.25Zm0,14.676a3.877,3.877,0,0,0,3.873-3.873V17.161a3.873,3.873,0,0,0-7.746,0v4.892A3.877,3.877,0,0,0,23.161,25.926Z",
    transform: "translate(21.887 12.226)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91187",
    "data-name": "Path 91187",
    d: "M32.622,15.288H3.269a1.019,1.019,0,0,1,0-2.038H32.622a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(0.196 15.119)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91188",
    "data-name": "Path 91188",
    d: "M9.269,28.711A1.019,1.019,0,0,1,8.25,27.692V18.519a1.019,1.019,0,1,1,2.038,0v9.173A1.019,1.019,0,0,1,9.269,28.711Z",
    transform: "translate(8.872 21.264)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91189",
    "data-name": "Path 91189",
    d: "M11.438,16.127a4.688,4.688,0,1,1,4.688-4.688A4.694,4.694,0,0,1,11.438,16.127Zm0-7.338a2.65,2.65,0,1,0,2.65,2.65A2.653,2.653,0,0,0,11.438,8.788Z",
    transform: "translate(6.703 5.719)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132489",
    "data-name": "Group 132489",
    transform: "translate(191.068 585.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95933",
    "data-name": "Path 95933",
    d: "M-9209.957-10370.246v19.494",
    transform: "translate(9219.705 10370.246)",
    fill: "none",
    stroke: "#09143a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95934",
    "data-name": "Path 95934",
    d: "M0,0V19.494",
    transform: "translate(19.494 9.747) rotate(90)",
    fill: "none",
    stroke: "#09143a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "car",
    transform: "translate(123.999 570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91190",
    "data-name": "Path 91190",
    d: "M15.5,2.08H33.066c3.154,0,5.433.763,6.968,2.333A10.453,10.453,0,0,1,42.47,9.794L45.3,23.331a1.019,1.019,0,0,1-1,1.228H4.269a1.019,1.019,0,0,1-1-1.228L6.1,9.8A10.455,10.455,0,0,1,8.535,4.413C10.07,2.843,12.349,2.08,15.5,2.08ZM43.046,22.521,40.475,10.213a8.7,8.7,0,0,0-1.9-4.375c-1.131-1.157-2.934-1.72-5.51-1.72H15.5c-2.577,0-4.379.563-5.51,1.72a8.7,8.7,0,0,0-1.9,4.376L5.523,22.521Z",
    transform: "translate(1.75 -2.08)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91191",
    "data-name": "Path 91191",
    d: "M47.2,39.809H42.5c-3.428,0-4.031-1.808-4.515-3.261l-.514-1.54c-.672-1.968-.923-2.7-3.778-2.7H20.881a4.05,4.05,0,0,0-2.794.732,4.8,4.8,0,0,0-.993,2l-.5,1.514C16.106,38,15.5,39.809,12.075,39.809h-4.7a6.175,6.175,0,0,1-4.561-2,5.968,5.968,0,0,1-1.533-4.565l1.4-15.235c.178-1.9.457-3.883,1.724-5.386C5.766,11,7.966,10.25,11.324,10.25H43.248c3.358,0,5.558.753,6.921,2.37A9.407,9.407,0,0,1,51.894,18l1.4,15.238a5.967,5.967,0,0,1-1.533,4.563A6.175,6.175,0,0,1,47.2,39.809Zm-26.32-9.544h12.81c4.312,0,4.99,1.984,5.707,4.085l.011.033,0,.007.5,1.514a3.431,3.431,0,0,0,.674,1.4,2.812,2.812,0,0,0,1.907.472h4.7a4.132,4.132,0,0,0,3.053-1.338,3.874,3.874,0,0,0,1.011-3l-1.4-15.239c-.343-3.673-.959-5.9-6.616-5.9H11.324c-5.657,0-6.273,2.231-6.616,5.906l-1.4,15.235a3.875,3.875,0,0,0,1.011,3,4.132,4.132,0,0,0,3.053,1.338h4.7a2.812,2.812,0,0,0,1.907-.472,3.43,3.43,0,0,0,.674-1.4l.5-1.514C15.805,32.456,16.536,30.265,20.881,30.265Z",
    transform: "translate(-1.252 10.191)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91192",
    "data-name": "Path 91192",
    d: "M5.771,9.288h-2.5a1.019,1.019,0,1,1,0-2.038h2.5a1.019,1.019,0,1,1,0,2.038Z",
    transform: "translate(0.248 5.685)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91193",
    "data-name": "Path 91193",
    d: "M22.771,9.288h-2.5a1.019,1.019,0,1,1,0-2.038h2.5a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(25.781 5.685)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91194",
    "data-name": "Path 91194",
    d: "M12.269,9.292A1.019,1.019,0,0,1,11.25,8.273v-5a1.019,1.019,0,0,1,2.038,0v5A1.019,1.019,0,0,1,12.269,9.292Z",
    transform: "translate(13.765 -1.825)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91195",
    "data-name": "Path 91195",
    d: "M18.275,6.288H10.769a1.019,1.019,0,0,1,0-2.038h7.506a1.019,1.019,0,1,1,0,2.038Z",
    transform: "translate(11.512 1.179)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91196",
    "data-name": "Path 91196",
    d: "M13.775,16.288H6.269a1.019,1.019,0,1,1,0-2.038h7.506a1.019,1.019,0,1,1,0,2.038Z",
    transform: "translate(4.754 16.198)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91197",
    "data-name": "Path 91197",
    d: "M22.775,16.288H15.269a1.019,1.019,0,0,1,0-2.038h7.506a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(18.271 16.198)",
    fill: "#09143a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoplushome);
export default __webpack_public_path__ + "static/media/autoplushome.8f74414912f9b3daefc2501a1e8ffb3c.svg";
export { ForwardRef as ReactComponent };